import clsx from 'clsx';

export interface SliderProgressProps {
  /** Całkowita liczba slajdów */
  totalSlides: number;
  /** Aktualny postęp (0-1) lub indeks aktywnego slajdu */
  progress: number;
  /** Czy progress jest wartością 0-1 (true) czy indeksem slajdu (false) */
  isProgressValue?: boolean;
  /** Kolor tła (domyślnie primary z opacity) */
  bgColor?: string;
  /** Kolor obramowania (domyślnie primary) */
  borderColor?: string;
  /** Kolor aktywnego wskaźnika (domyślnie primary) */
  activeColor?: string;
  /** Dodatkowe klasy CSS */
  className?: string;
}

export const SliderProgress = ({
  totalSlides,
  progress,
  isProgressValue = true,
  bgColor = 'bg-primary/20',
  borderColor = 'border-primary',
  activeColor = 'bg-primary',
  className,
}: SliderProgressProps) => {

  // Szerokość pojedynczego segmentu
  const segmentWidth = 100 / totalSlides;

  // Oblicz pozycję i szerokość aktywnego wskaźnika
  const activeWidth = segmentWidth;
  const activePosition = isProgressValue
    ? progress * (100 - segmentWidth)
    : totalSlides > 1
      ? (progress / (totalSlides - 1)) * (100 - segmentWidth + 2)
      : 2;

  return (
    <div
      className={clsx(
        'relative rounded-full border h-[10px] backdrop-blur-[10px]',
        bgColor,
        borderColor,
        className,
      )}
    >
      <div
        className={clsx('absolute rounded-full transition-all duration-300 ease-out top-[2px] bottom-[2px]', activeColor)}
        style={{
          left: `calc(${activePosition}% + 3px)`,
          width: `calc(${activeWidth}% - 5px)`,
        }}
      />
    </div>
  );
};
